namespace SP {

    var current: any = {};

    export interface SwipeButtonInfo {
        icon: string;
        text: string;
        color: string;
        confirm: boolean;
        action: () => Promise<void>;
    }


    export class SwipeMenu {
        item: HTMLElement;
        hasTouch = false;
        itemX = 0;
        startX = 0;
        startY = 0;
        offsetX = 0;
        lastOffsetX = 0;
        offsetY = 0;

        posX = 0;
        width = -1;
        buttonWidth = -1;
        height = -1;
        openThreshold = 0;
        closeThreshold = 0;
        autoClickThreshold = 0;
        initialized = false;
        clicked = true;
        clickEvent: () => void;
        buttonData: SwipeButtonInfo[];
        buttons: HTMLElement[] = [];
        triggerMax = false;
        triggerOpen = false;
        group: string;
        destroyed = false;
        isOpen = false;
        isOpenMax = false;


        constructor(element: HTMLElement, clickEvent: () => void, buttons: SwipeButtonInfo[], group: string) {
            this.item = element;
            this.item.classList.add("sp_swipemenu");
            this.buttonData = buttons;
            this.clickEvent = clickEvent;
            this.group = group;
            var touchMove = (ev: any) => {
                if (!ev.clientX && ev.touches && ev.touches.length)
                    ev = ev.touches[0];

                var x = ev.clientX;
                var y = ev.clientY;
                this.offsetX = this.startX - x;
                this.offsetY = this.startY - y;

                //zoom fix
                this.offsetX /= SP.zoom();
                this.offsetY /= SP.zoom();

                if (Math.abs(this.offsetY) > Math.abs(this.offsetX))
                    this.offsetX = 0;

                var maxOffset = Math.max(Math.abs(this.offsetX), Math.abs(this.offsetY));
                this.posX = Math.min(this.width * 0.95, Math.max(0, this.itemX + this.offsetX));

                if (!this.initialized && maxOffset > 0) {
                    this.initialize();
                }

                if (this.posX > this.autoClickThreshold) {
                    if (!this.triggerMax) {
                        Sounds.Vibrate.play(25);
                        this.setEase();
                        this.openMax();
                        this.triggerMax = true;
                    }
                }
                else {
                    if (this.triggerMax) {
                        this.setEase();
                        this.triggerMax = false;
                        this.clearEase(100);
                    }

                    if (this.offsetX != this.lastOffsetX) {
                        this.lastOffsetX = this.offsetX;
                        this.item.style.right = this.posX + "px";
                        for (var i = 0; i < this.buttons.length; i++) {
                            var left = this.width + i * this.buttonWidth;
                            this.buttons[i].style.left = (left - this.posX) + "px";
                        }
                    }
                }

                var maxOffset = Math.max(Math.abs(this.offsetX), Math.abs(this.offsetY));


                if (this.clicked && maxOffset > 3) {
                    this.clicked = false;
                }
            }



            var touchStart = (ev: any) => {
                if (this.destroyed) return;
                if (!ev.clientX && ev.touches && ev.touches.length)
                    ev = ev.touches[0];

                if (ev.button != null && ev.button != 0) return;
                if (!this.hasTouch) {
                    if (this.initialized) this.updateSizes();


                    if (current[this.group] != this) {
                        current[this.group]?.return();
                        current[this.group] = this;
                    }
                    this.posX = 0;

                    this.clicked = true;
                    //this.insertButtons();
                    this.hasTouch = true;
                    this.startX = ev.clientX;
                    this.startY = ev.clientY;
                    this.itemX = parseInt(this.item.style.right.replace("px", ""));
                    if (isNaN(this.itemX)) this.itemX = 0;
                    //move
                    document.addEventListener("touchmove", touchMove);
                    document.addEventListener("mousemove", touchMove);

                    //up
                    document.addEventListener("touchend", touchEnd);
                    document.addEventListener("touchcancel", touchEnd);
                    document.addEventListener("mouseup", touchEnd);
                    this.clearEase();
                }
            }

            var touchEnd = () => {
                if (this.hasTouch) {

                    this.hasTouch = false;
                    //up
                    document.removeEventListener("touchmove", touchMove);
                    document.removeEventListener("mousemove", touchMove);
                    document.removeEventListener("touchend", touchEnd);
                    document.removeEventListener("touchcancel", touchEnd);
                    document.removeEventListener("mouseup", touchEnd);



                    //click last button
                    if (this.posX > this.autoClickThreshold) {
                        if (this.buttons.length)
                            this.buttons[this.buttons.length - 1].click();
                    }
                    else if (this.posX > (this.isOpen ? this.closeThreshold : this.openThreshold)) {
                        this.setEase();
                        this.open();
                    }
                    else {
                        this.setEase();
                        this.return();
                    }

                    //this.item.style.right = "0px";

                    if (this.clicked && this.clickEvent != null) {
                        this.clickEvent();
                    }

                }
            }

            this.item.addEventListener("mousedown", touchStart);
            this.item.addEventListener("touchstart", touchStart);
        }

        setEase() {

            this.item.style.transition = "all ease-out 0.1s";
            this.buttons.forEach(b => b.style.transition = "all ease-out 0.1s");

        }

        click() {
            this.clickEvent();
        }

        async clearEase(delay: number = 0) {
            await SP.sleep(delay);
            this.item.style.transition = "";
            this.buttons.forEach(b => b.style.transition = "");
        }

        openMax() {
            var right = this.width + (this.buttons.length - 1) * this.buttonWidth;
            this.item.style.right = right + "px";
            for (var i = 0; i < this.buttons.length; i++) {
                var left = this.width + i * this.buttonWidth;
                this.buttons[i].style.left = (left - right) + "px";
            }
            this.isOpenMax = true;

        }

        open() {
            var right = this.buttons.length * this.buttonWidth;
            this.item.style.right = right + "px";
            for (var i = 0; i < this.buttons.length; i++) {
                var left = this.width + i * this.buttonWidth;
                this.buttons[i].style.left = (left - right) + "px";
            }
            this.isOpen = true;
        }

        remove() {
            this.destroyed = true;
            this.buttons.forEach(b => b.remove());
        }

        async return(animateReturn: boolean = true) {
            if (!this.initialized) return;


            if (!animateReturn)
                await this.clearEase();


            this.item.style.right = "0px";
            for (var i = 0; i < this.buttons.length; i++) {
                var left = this.width + i * this.buttonWidth;
                this.buttons[i].style.left = left + "px";
            }

            this.isOpen = false;
            this.isOpenMax = false;
        }

    

        initialize() {
            if (this.initialized) return;
            this.initialized = true;
            this.item.style.left = "";






            for (let i = 0; i < this.buttonData.length; i++) {
                let last = i == this.buttonData.length - 1;
                let data = this.buttonData[i];
                let button = document.createElement("div");
                button.classList.add("sp_swipe_button", "noselect");
                button.style.backgroundColor = data.color;
                button.innerHTML = "<div><span class='icon'>" + data.icon + "</span><br />" + data.text + "</div>";
                if (data.action != null) button.addEventListener("click", async () => {
                    if (data.confirm) {
                        if (await SP.confirmX("Confirm")) { data.action(); }
                        else { this.return(true); }
                    }
                    else {
                        data.action();
                    }
                });
                if (last) button.style.right = "0px";
                this.buttons.push(button);
            }

            this.insertButtons();
            this.updateSizes();
        }

        updateSizes() {
            var computed = getComputedStyle(this.item);
            this.item.style.width = computed.width;
            var width = parseInt(computed.width.replace("px", ""));
            var height = parseInt(computed.height.replace("px", ""));

            if (this.width != width || this.height != height) {
                this.width = width;
                this.height = height;
                this.buttonWidth = Math.min(this.height, this.width * 0.25);
                this.autoClickThreshold = this.width * 0.6;
                this.openThreshold = this.width * 0.2;
                this.closeThreshold = this.width * 0.4;

                var left = this.width;

                for (let i = 0; i < this.buttons.length; i++) {
                    let button = this.buttons[i];
                    button.style.minWidth = this.buttonWidth + "px";
                    button.style.height = this.height + "px";
                    button.style.left = left + "px";
                    left += this.buttonWidth;
                }
            }
        }

        insertButtons() {
            this.buttons.forEach(b => {
                SP.insertBefore(b, this.item);
            });

        }




    }
}